import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/app/')({
  component: AppIndex,
})

/**
 * The bare `/app`, which is not a page.
 *
 * `/app` is a prefix that means "this needs membership", not a destination. It
 * exists so the gate above has somewhere to live. Without this, reaching it
 * passes the gate and then renders an empty shell — a door that opens onto
 * nothing — so it forwards to the briefs, which is where a member's work is.
 */
function AppIndex() {
  return <Navigate to="/app/briefs" replace />
}
